import React  from 'react';
import { Link } from "react-router-dom";
import DataTable, { CustomLoader } from 'react-data-table-component';
import { CertTypeCombobox } from './CertTypeCombobox';
import FormatStandardDate from './FormatStandardDate';
//Ref:
// https://codesandbox.io/s/j20zn?file=/src/Components/OrFilterPanel.js
// https://react-data-table-component.netlify.app/?path=/docs/
const columns = [
  {
    name: 'Id',
    width: '130px',
    selector: row => <Link to={{ pathname: '/details', query: { authorityId: row.authorityName, requestId: row.id } }}>{row.id}</Link>
  },
  {
    name: 'Date',
    width: '140px',
    selector: row => row.requestDate,
  },
  {
    name: 'LastName',
    width: '110px',
    selector: row => row.lastName
  },
  {
    name: 'FirstName',
    width: '100px',
    selector: row => row.firstName
  },
  {
    name: 'Dob',
    width: '100px',
    selector: row => FormatStandardDate(row.dob)
  },
  {
    name: 'Vax Count',
    width: '80px',
    selector: row => row.vaccinationCount
  },
  {
    name: 'Cert Type',
    width: '100px',
    selector: row => row.certificateType
  },
  {
    name: 'Render Cert Type',
    width: '180px',
    ignoreRowClick: true,
    cell: (row) => <><CertTypeCombobox className='btn btn-primary' selectedCertLabel={row.certificateType} onChange={(e) => row.certificateTypeValue = e} /></> 
  },
  {
    name: 'Meets',
    width: '80px',
    selector: row => row.meetsRequirements ? "TRUE" : "FALSE"
  },
  {
    name: 'Details',
    button: true,
    compact: true,
    width: '80px',
    selector: row => <button type='button' className='btn btn-primary' value='View' onClick={() => requestDetails(row.authorityName, row.id, row.certificateType)}>View</button>
    //selector: row => <Link type='button' className='btn btn-primary' to={{ pathname: '/details', query: { authorityId: row.authorityName, requestId: row.id, serverInstance: serverInstance, certType: row.certificateType, certTypeValue: row.certificateTypeValue } }}>Details</Link>
  },
  {
    name: 'Test',
    button: true,
    compact: true,
    width: '70px',
    selector: row => <Link type='button' className='btn btn-primary' to={{ pathname: '/testResult', query: { dataSource: dataSource, serverInstance: serverInstance, authorityId: row.authorityName, requestId: row.id } }}>Test</Link>
  },
  {
    name: 'Certificate',
    button: true,
    compact: true,
    width: '80px',
    selector: row => <button type='button' className='btn btn-primary' value='View' onClick={() => requestCertificate(row.authorityName, row.id, row.certificateTypeValue)}>View</button>
  }
];

const requestCertificate = (authorityId, requestId, certType) => {
  console.log('Requesting certificate');
  table.props.handleDownloadCertificate(dataSource, serverInstance, authorityId, requestId, certType);
}

const requestDetails = (authorityId, requestId, certType) => {
  console.log('Requesting details');
  table.props.handleShowRequestDetails(dataSource, authorityId, requestId, certType);
}


var serverInstance = "";
var dataSource = "";

const SearchBar = () => {
  return (
    <form>
      <input
        type="text"
        className='form-control'
        placeholder="Search results..."
      />

    </form>
  );
}

var table = {}

const RequestDataTable = (props) => {
  table.props = props;
  serverInstance = props.serverInstance;
  dataSource = props.dataSource;

  if (props.isSearching === true) {
    return (
      <div className = "row justify-content"><h5>Searching...</h5></div>
    );
  }

  return (
    
    <div>
      {(props.data != null && props.data.length > 0) &&
        <div className="row justify-content-start">
          <div className="col-md-4">
            <h5>Log Entries</h5>
          </div>
        </div>
      }

      <div className="row">
        <DataTable
          fixedHeader
          paginationDefaultPage={props.currentPage}
          serverInstance={props.serverInstance}
          pagination
          columns={columns}
          data={props.data}
          selectableRows
          onChangePage={props.onChangePage}
        />
      </div>
    </div>
  );
}

//fixedHeaderScrollHeight="600px"

export { SearchBar, RequestDataTable }